async function handleColorSiblingsChanged(event) {
    const target = event.target;
    const productBlock = target?.closest('.product-block');
    if (!productBlock) {
        return;
    }
    await renderNewProduct(productBlock, target);
}

async function renderNewProduct(productBlock, target) {
    try {
        // Get original aspect ratio before fetching new content
        const originalImgAr = productBlock.querySelector('.img-ar');
        const originalAspectRatio = originalImgAr?.style.getPropertyValue('--aspect-ratio') ||
            getComputedStyle(originalImgAr).getPropertyValue('--aspect-ratio').trim();

        const productHandle = target.getAttribute('data-variant-handle');
        const productUrl = target.getAttribute('data-product-url')?.replace('/products/', '');
        if(!productHandle && !productUrl) {
            console.log('productHandle or productId not found');
            return;
        }
        const handle = productHandle ? productHandle : productUrl;
        const response = await fetch(`/products/${handle}?sections=boa-product-block-item`);
        const data = await response.json();
        const html = data['boa-product-block-item'];
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const newProductBlock = doc.querySelector('product-block');
        if (!newProductBlock) {
            throw new Error('newProductBlock not found');
        }
        // Apply original aspect ratio to new image containers
        if (originalAspectRatio) {
            const imageContainers = newProductBlock.querySelectorAll('.img-ar');
            imageContainers.forEach(container => {
                container.style.setProperty('--aspect-ratio', originalAspectRatio);
            });
        }
        
        productBlock.replaceWith(newProductBlock);
        
        // Wait for images to load before recalculating heights
        const images = newProductBlock.querySelectorAll('img');
        const imagePromises = Array.from(images).map(img => {
            if (img.complete) return Promise.resolve();
            return new Promise(resolve => {
                img.onload = () => resolve();
                img.onerror = () => resolve();
                setTimeout(() => resolve(), 1000); // Timeout after 1 second
            });
        });
        
        await Promise.all(imagePromises);
        
        // Recalculate heights after images loaded
        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                if (window.theme?.quickbuy?.setBlockHeights) {
                    window.theme.quickbuy.setBlockHeights(newProductBlock);
                }
            });
        });
    }
    catch(e) {
        console.error('error in renderNewProduct: ' + e);
    }
}
